import { render, staticRenderFns } from "./Placeholders.vue?vue&type=template&id=126f0723&"
import script from "./Placeholders.vue?vue&type=script&lang=js&"
export * from "./Placeholders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports